<template>
  <table class="lapse-table">
    <tbody>
      <tr v-for="(l, i) in lapses" :key="i">
        <td class="mono yellow lighten-4 px-2">{{ l.bytes | prettyHex }}</td>
        <td class="px-2">lapseIndex={{i}} {{ l | prettyLapse }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import brush from 'brush'
import _ from 'lodash'
import moment from 'moment'

export default {
  props: {
    value: {}
  },
  computed: {
    lapses() {
      if (this.value == null) return []
      if (Array.isArray(this.value)) return this.value
      return [this.value]
    }
  },
  filters: {
    prettyHex(x) {
      if (x == null) return '-'
      return brush.toHex(x, { prettyPrint: true, bytesPerLine: 32 })
    },
    prettyLapse(x) {
      return strLapse(x)
    }
  }
}

function strLapse(lapse, sep='\n') {
  if ( lapse == null ) return '-'

  let lines = _.reduce(lapse, (acc, val, key) => {
    if ( val == null || key == 'startIndex' ||
         key == 'endIndex' || key == 'bytes' ||
         key == 'type' || key == 'lapseIndex' ||
         key == 'log' ||
         key == 'timestamp' ) return acc
    if ( _.isArray(val) ) val = `[${val.join(',')}]`
    if ( _.isDate(val) || moment.isMoment(val) )
      val = moment(val).format()

    if ( _.isPlainObject(val) ) val = JSON.stringify(val)

    acc.push(`${key}=${val.toString()}`)
    return acc
  }, [])

  lines = lines.sort()

  // Começa com o lapseIndex, timestamp, e log (se existirem)
  // NB: como todos estes usam unshift() eles são colocados
  // na ordem inversa
  if ( lapse.log != null )
    lines.unshift(`log=${lapse.log}`)

  if ( lapse.lapseIndex != null )
    lines.unshift(`lapseIndex=${lapse.lapseIndex}`)

  if ( lapse.timestamp != null )
    lines.unshift(`timestamp=${moment(lapse.timestamp).format()}`)

  return lines.join(sep)
}
</script>

<style>
.lapse-table {
  border-collapse: collapse;
}

.lapse-table tr {
  border-bottom: 1px solid #ddd;
}
</style>
